import { BasicCommand } from "./BasicCommand";
/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 29.04.13
 * Time: 11:36
 * To change this template use File | Settings | File Templates.
 */


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { CommandController } from './../../../commanding/CommandController';

export class VPMCommand extends BasicCommand {

    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_VERIFY_PLAYER_MAIL_EVENT;
    }

    public executeCommand(error: number, params: any[]): boolean {
        CommandController.instance.executeCommand(BasicController.COMMAND_VERIFY_PLAYER_MAIL, error);
        return super.executeCommand(error, params);
    }
}

